<app-go-to-parent-slide-button
    [disabled]="(isDisabled$ | async) === true"
    (goToParentClicked)="goToParentSlide()"
></app-go-to-parent-slide-button>
